import { Component } from 'react'

import { telemetryClient } from '~/lib/telemetry'
import { generateSpanId } from '~/lib/telemetry/logs'

import { DefaultErrorFallback } from './DefaultErrorFallback'

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false, error: null, spanId: '' }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    const spanId = generateSpanId()
    return { hasError: true, error, spanId }
  }

  defaultSpanId = generateSpanId()

  componentDidCatch(error: Error) {
    telemetryClient.logError({
      message: `Error from ErrorBoundary<${this.props?.name ?? 'App'}>: ${error.message}`,
      bodyError: error,
      spanId: this.state.spanId
    })
  }

  reset = (refresh = false) => {
    if (refresh && typeof window !== 'undefined' && window.location) {
      return window.location.reload()
    }
    this.setState({ hasError: false, error: null })
  }
  render() {
    const { hasError, error, spanId } = this.state
    const { fallback, children, errorComponentProps } = this.props

    const ErrorComponent = fallback || DefaultErrorFallback

    if (hasError && error) {
      return (
        <ErrorComponent
          error={error}
          reset={this.reset}
          code={spanId}
          {...errorComponentProps}
        />
      )
    }

    return <>{children}</>
  }
}
